
























import { DataParse } from "@wj/common";
import { Vue, Component } from "vue-property-decorator";
import { addDeliverReq } from "@/common/class/h5/index";
import { deliverResume, getJobs } from "@/api/h5/index";
import { Cell, Form, Field, Button, Loading, Popup, Icon, Picker, Toast } from "vant";

@Component({
  components: {
    [Cell.name]: Cell,
    [Form.name]: Form,
    [Field.name]: Field,
    [Button.name]: Button,
    [Loading.name]: Loading,
    [Popup.name]: Popup,
    [Icon.name]: Icon,
    [Picker.name]: Picker,
  },
})
export default class empowermentQueryComponent extends Vue {
  loading = false;
  showJobPicker = false;
  jobList: any = [];
  addReq = new addDeliverReq();
  created() {
    if (this.$route.query.id) {
      this.addReq.itineraryId = this.$route.query.id;
    }
    this.getJobList(this.$route.query.id);
  }
  mounted() {}
  goBack() {
    this.$router.push("home");
  }
  // 获取岗位列表
  getJobList(id:any) {
    getJobs({itineraryId:id})
      .then((res) => {
        const { data, message, success } = res;
        if (success) {
          this.jobList = data;
        }
      })
      .finally(() => {});
  }

  // 岗位选择确认
  onJobConfirm(value: any, index: any) {
    this.addReq.jobName = value.jobName;
    this.addReq.jobId = value.id;
    this.showJobPicker = false;
  }
  // 岗位选择取消
  onJobCancel(value: any, index: any) {
    this.showJobPicker = false;
    // this.editResumeReq.education = "";
    // this.editResumeReq.educationId = "";
  }

  onSubmit(value: any) {
    this.loading = true;
    deliverResume(this.addReq)
      .then((res) => {
        const { data, message, success } = res;
        if (success) {
          Toast.success("投递成功！");
          this.$router.push({ path: "itineraryDetail", query: { id: this.addReq.itineraryId } });
        }
      })
      .finally(() => {
        this.loading = false;
      });
  }
  onFailed(errorInfo: any) {
    if (errorInfo.errors.length > 0) {
      Toast("请填写完整星号内容！");
    }
  }
}
